<div *ngIf="isOpen" class="modal-overlay">
  <div class="modal-container">
    <div class="modal-header-wrapper">
      <div class="modal-header">
        <h2 class="modal-title">Export contacts</h2>
        <button type="button" class="close-button" (click)="onClose()"
          ><span class="pi pi-times"></span
        ></button>
      </div>
      <p class="description">Choose format and select columns to include</p>
    </div>

    <div class="modal-body-content">
      <div class="section-title">EXPORT FORMAT</div>
      <div class="formats-row">
        @for (option of exportOptions; track $index) {
          <div
            class="export-format-option"
            [class.selected]="isSelected(option.format)"
            [class.hidden]="!isFormatAvailable(option.format)"
            (click)="selectOption(option.format)"
          >
            <div class="format-content">
              <span class="file-icon" [ngClass]="option.format + '-icon'">{{
                option.icon
              }}</span>
              <span class="format-label">{{ option.label }}</span>
            </div>
            <span *ngIf="isSelected(option.format)" class="format-check"
              ><i class="pi pi-check"></i
            ></span>
          </div>
        }
      </div>

      <ng-container *ngIf="columns && columns.length > 0">
        <div class="section-title columns-header">
          <span>COLUMNS TO EXPORT</span>
          <span class="selected-count"
            >{{ selectedColumns.size }} of {{ columns.length }} selected</span
          >
        </div>

        <div
          class="select-all-box"
          [class.indeterminate]="!isAllColumnsSelected && isIndeterminate"
          [class.selected]="isAllColumnsSelected"
          (click)="toggleSelectAll()"
        >
          <div class="select-all-left">
            <div class="custom-checkbox">
              <i *ngIf="isAllColumnsSelected" class="pi pi-check"></i>
              <i
                *ngIf="!isAllColumnsSelected && isIndeterminate"
                class="pi pi-minus"
              ></i>
            </div>
            <span class="select-all-label">Select all columns</span>
          </div>
          <div class="all-count-badge">All {{ columns.length }}</div>
        </div>

        <div class="columns-grid">
          @for (col of columns; track col.value) {
            <div
              class="column-option"
              [class.selected]="isColumnSelected(col.value)"
              [class.disabled]="col.disabled"
              (click)="!col.disabled && toggleColumn(col.value, $event)"
            >
              <div class="custom-checkbox">
                <i *ngIf="isColumnSelected(col.value)" class="pi pi-check"></i>
              </div>
              <!-- <span *ngIf="col.icon" class="column-icon" [innerHTML]="col.icon | safeHtml"></span> -->
              <span
                *ngIf="col.icon?.startsWith('pi')"
                class="column-icon pi-icon"
                [ngClass]="col.icon"
              ></span>
              <span class="column-label">{{ col.label }}</span>
            </div>
          }
        </div>
      </ng-container>
    </div>

    <!-- <div class="note">
      Note: we don't currently support PowerPoint or Google Slider export, but
      we'll be exploring this in the future.
    </div> -->

    <div class="modal-footer">
      <div class="footer-status">
        <span *ngIf="columns && columns.length > 0"
          >Exporting {{ isAllColumnsSelected ? 'all' : selectedColumns.size }}
          {{ selectedColumns.size === 1 ? 'column' : 'columns' }} as
          {{ selectedFormat.toUpperCase() }}</span
        >
      </div>
      <div class="footer-actions">
        <g99-button
          color="white"
          [disabled]="isLoading"
          (buttonClick)="onClose()"
        >
          Cancel
        </g99-button>
        <g99-button
          color="secondary"
          [disabled]="
            isLoading ||
            (columns && columns.length > 0 && selectedColumns.size === 0)
          "
          [isLoading]="isLoading"
          [loadingText]="'Exporting'"
          (buttonClick)="onExport()"
        >
          Export
        </g99-button>
      </div>
    </div>
  </div>
</div>
